import {useAui} from '@assistant-ui/react';
import {useCallback} from 'react';

import {useTrackWBAgentChats} from './useTrackWBAgent';
import {useWBAgentContextStore} from './WBAgentContextStore';

export function useNewChat(): () => void {
  const aui = useAui();
  const clearRuns = useWBAgentContextStore(s => s.clearRuns);
  const {trackChatCreated} = useTrackWBAgentChats();

  return useCallback(() => {
    aui.threads().switchToNewThread();
    clearRuns();
    trackChatCreated();
  }, [aui, clearRuns, trackChatCreated]);
}
